import { j as o } from "./jsx-runtime-C5mzlN2N.js";
import n from "styled-components";
import "./components/Theme/themes.es.js";
import "./palettes-Bw24w7AF.js";
import { getRadii as a } from "./components/Theme/utils.es.js";
import { forwardRef as m, useMemo as c, Suspense as p } from "react";
import "./CssBaseline-Bp4jdUgb.js";
import l from "./components/Icon/variants.es.js";
import "./components/Icon/countryVariants.es.js";
import { sizeStyles as d, variantStyles as f } from "./components/Icon/checkIconStyles.es.js";
const x = m((r, i) => {
  const {
    variant: t,
    ...e
  } = r, s = c(() => l[t], [t]);
  return /* @__PURE__ */ o.jsx(p, { children: /* @__PURE__ */ o.jsx(
    s,
    {
      ...e,
      ref: i
    }
  ) });
}), u = n.div`
  display: inline-flex;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;

  border-radius: ${a("full")};

  ${(r) => d[r.$size]};
  ${(r) => f[r.$variant]}
`, R = (r) => {
  const {
    variant: i = "ghost",
    color: t = "brand",
    size: e = "md",
    className: s
  } = r;
  return /* @__PURE__ */ o.jsx(
    u,
    {
      className: s,
      $variant: i,
      $color: t,
      $size: e,
      children: /* @__PURE__ */ o.jsx(x, { variant: "check" })
    }
  );
};
export {
  R as C,
  x as I
};
